<div
    style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
    <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
    </button>
</div>


<mat-dialog-content class="box-share-content">
    <div class="main-box-title-32" style="margin-bottom: 25px ;"> Confirm Delete Project</div>
    <div>
        <div class="main-box-title-18">Once you delete this project, it will be removed from our servers completely and you won't be able to get it back. Please confirm that you want to proceed.</div>
        <div style="margin-top: 40px;">
        </div>
    </div>

    <div class="box-button">
        <button class="cancel-btn" mat-dialog-close>
            <img class="cancel-img" src="./assets/images/yellow_icons/cancel-icon.svg">
            <span><u class="main-box-value-16-bold">Cancel</u></span>
        </button>
        <button class="analysis-button" (click)="deleteProyect()">
            <span class="main-box-title-16" style="font-weight: 600;">
                Remove Project</span> </button>
    </div>
</mat-dialog-content>
